import { render, staticRenderFns } from "./LvQrcode.vue?vue&type=template&id=587dee34"
import script from "./LvQrcode.vue?vue&type=script&lang=js"
export * from "./LvQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports